import { Button, Drawer, Select, Modal } from 'antd'
import { CloseOutlined as CloseIcon } from '@ant-design/icons'
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { getTranscriptionContent } from 'utils/api'
import { Transcription } from './transcription'
import { useIsMobile } from 'common/hooks'

const TRANSCRIPTION_LABEL = "Transcription"

const _TranscriptionsWidget = ({
  transcriptions,
  opened,
  onClose
}) => {
  const [transcriptionValue, setTranscriptionValue] = useState('')
  const [transcriptionsContent, setTranscriptionsContent] = useState({})
  const [loadingTranscriptions, setLoadingTranscriptions] = useState(false)
  const isMobile = useIsMobile()

  const defaultLanguage = useMemo(() => {
    return transcriptions.find(transcription => 
      transcription.srcLang === "en-US"
    )?.label ?? transcriptions[0].label
  }, [transcriptions])

  useEffect(() => {
    const fetchUrls = async () => {
      const transcriptionsContentRes = {}
      setLoadingTranscriptions(true)
      for (const { src, label } of transcriptions) {
        const transcription = await getTranscriptionContent(src)
        transcriptionsContentRes[label] = transcription
      }
      setTranscriptionsContent(transcriptionsContentRes)
      setTranscriptionValue(transcriptionsContentRes[defaultLanguage])
      setLoadingTranscriptions(false)
    }
    fetchUrls()
  }, [transcriptions, defaultLanguage])

  const onSelectChange = useCallback((newValue) => {
    setTranscriptionValue(transcriptionsContent[newValue])
  }, [transcriptionsContent, setTranscriptionValue])

  return (
    <>
      { isMobile ? 
        <Modal open={opened} className="transcription-modal-container" footer={[]} closable={false} rootClassName ="transcription-modal-container">
          <div className="transcription-modal-header transcriptions-header">
            <h2 className="modal-title">{TRANSCRIPTION_LABEL}</h2>
            <Button className="close-button" onClick={onClose} icon={<CloseIcon fontSize={24}/>} />
          </div>
          <div className="transcription-select-container">
            <Select
              defaultValue={{ label: defaultLanguage, value: defaultLanguage }}
              options={transcriptions.map(({label}) => ({ label, value: label }))} 
              onChange={onSelectChange} 
            />
          </div>
          <div className="transcription-modal-body">
            <Transcription transcriptionStr={transcriptionValue} loading={loadingTranscriptions}/>
          </div>
        </Modal>
       :
        <div className="transcriptions-container">
          <Drawer
            title={TRANSCRIPTION_LABEL}
            placement="right"
            closable={false}
            open={opened}
            getContainer={false}
            autoFocus={false}
            extra={
              <div className="transcription-options transcriptions-header">
                <Select
                  defaultValue={{ label: defaultLanguage, value: defaultLanguage }}
                  options={transcriptions.map(({label}) => ({ label, value: label }))} 
                  onChange={onSelectChange} 
                />
                <Button className="close-button" onClick={onClose} icon={<CloseIcon fontSize={24}/>} />
              </div>
            }
          >
            <Transcription transcriptionStr={transcriptionValue} loading={loadingTranscriptions}/>
          </Drawer>
        </div> 
      }
    </>
  )
}

export const TranscriptionsWidget = memo(_TranscriptionsWidget)